module.exports = __webpack_public_path__ + "img/intro-instructions.543ccaf7.jpg";